import React from 'react';
import { FiUser, FiBell, FiShield, FiGlobe, FiDatabase } from 'react-icons/fi';

const Settings = () => {
  return (
    <div className="container-fluid p-0">
      <h2 className="fw-bold mb-4">System Settings</h2>
      
      <div className="row g-4">
        <div className="col-lg-3">
          <div className="glass-card p-3">
            <div className="nav flex-column nav-pills gap-2">
              <button className="nav-link active text-start d-flex align-items-center gap-2"><FiUser /> Profile</button>
              <button className="nav-link text-white text-start d-flex align-items-center gap-2 border-0 bg-transparent"><FiBell /> Notifications</button>
              <button className="nav-link text-white text-start d-flex align-items-center gap-2 border-0 bg-transparent"><FiShield /> Security</button>
              <button className="nav-link text-white text-start d-flex align-items-center gap-2 border-0 bg-transparent"><FiGlobe /> Language</button>
              <button className="nav-link text-white text-start d-flex align-items-center gap-2 border-0 bg-transparent"><FiDatabase /> API Keys</button>
            </div>
          </div>
        </div>

        <div className="col-lg-9">
          <div className="glass-card p-4">
            <h5 className="fw-bold mb-4">Profile Information</h5>
            <form>
              <div className="row g-3 mb-4">
                <div className="col-md-6">
                  <label className="form-label text-muted small fw-bold">Full Name</label>
                  <input type="text" className="form-control" defaultValue="Admin User" />
                </div>
                <div className="col-md-6">
                  <label className="form-label text-muted small fw-bold">Email Address</label>
                  <input type="email" className="form-control" defaultValue="admin@franchiseos.com" />
                </div>
                <div className="col-md-6">
                  <label className="form-label text-muted small fw-bold">Phone Number</label>
                  <input type="text" className="form-control" defaultValue="+1 234 567 890" />
                </div>
                <div className="col-md-6">
                  <label className="form-label text-muted small fw-bold">Role</label>
                  <input type="text" className="form-control" defaultValue="Super Admin" disabled />
                </div>
              </div>
              <button className="btn btn-primary px-4">Save Changes</button>
            </form>
          </div>

          <div className="glass-card p-4 mt-4 border-danger border-opacity-20">
            <h5 className="fw-bold text-danger mb-3">Danger Zone</h5>
            <p className="text-muted small">Once you deactivate the account, there is no going back. Please be certain.</p>
            <button className="btn btn-outline-danger btn-sm">Deactivate Account</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
